import Footer from "components/footer/Footer";
import Header from "components/header/Header";
import React from "react";
import UserAuth from "components/AuthGaurd/UserAuth";
import AddVet from "./AddVet";
type Props = {};

export default function AddVetForm({}: Props) {
  return (
    <UserAuth>
      <header>
        <Header />
      </header>
      <section id="hero">
        <div className="tw-w-full tw-bg-[#F7F7F7]">
          {/* first Item */}
          <div className="tw-flex tw-py-4 sm:tw-py-6 tw-pl-10  sm:tw-pl-12 md:tw-pl-14 tw-bg-[#F7F7F7] tw-items-center">
            <p className="tw-text-[24px] md:tw-text-[26px] lg:tw-text-[32px] tw-text-black tw-font-bold">
              Add Care Team
            </p>
          </div>
          {/* second Item */}

          <div className=" tw-top-[9.375rem] tw-w-full tw-flex tw-flex-col tw-pt-8 lg:tw-pb-36 tw-rounded-t-[2rem] tw-shadow-inner tw-relative">
            <div
              className="tw-absolute tw-inset-0 tw-bg-[url('/src/assets/images/section-bg.svg')] tw-bg-center tw-bg-no-repeat tw-bg-cover"
              style={{ mixBlendMode: "luminosity" }}
            ></div>
            {/* Rest of your content */}
            <div className="tw-flex tw-flex-col tw-gap-8">
              <AddVet />
            </div>
          </div>
        </div>
      </section>
      <footer className="tw-block">
        <Footer />
      </footer>
    </UserAuth>
  );
}
